import { formatearPrecio } from "../../../../../utils/utils";

export const generarPlanDePagos = (solicitudes) => {
    if (!solicitudes || solicitudes.length === 0) {
        return { resumen: [], asociaciones: [] };
    }

    // ✨ CAMBIO 1: Ahora guardamos el total Y la lista de solicitudes por fecha.
    const entregasPorFecha = solicitudes.reduce((acc, sol) => {
        const fechaClave = new Date(sol.proPlataforma.fechaRealUnad).toISOString().split('T')[0];
        if (!acc[fechaClave]) {
            // Inicializamos con un objeto que contiene el total y un arreglo para las solicitudes.
            acc[fechaClave] = { total: 0, solicitudes: [] };
        }
        acc[fechaClave].total += sol.proPlataforma?.precioEmpresa || 0;
        acc[fechaClave].solicitudes.push(sol); // Guardamos la solicitud completa.
        return acc;
    }, {});

    const fechasOrdenadas = Object.keys(entregasPorFecha).sort();
    if (fechasOrdenadas.length === 0) {
        return { resumen: [], asociaciones: [] };
    }

    const gruposDePago = [];
    // ✨ CAMBIO 2: El grupo actual ahora también incluye el arreglo de solicitudes.
    let grupoActual = {
        fechaInicio: new Date(fechasOrdenadas[0] + 'T00:00:00'),
        fechaFin: new Date(fechasOrdenadas[0] + 'T00:00:00'),
        total: entregasPorFecha[fechasOrdenadas[0]].total,
        solicitudes: entregasPorFecha[fechasOrdenadas[0]].solicitudes
    };

    for (let i = 1; i < fechasOrdenadas.length; i++) {
        const fechaActual = new Date(fechasOrdenadas[i] + 'T00:00:00');
        const diffDays = (fechaActual - grupoActual.fechaFin) / (1000 * 60 * 60 * 24);

        if (diffDays <= 6) {
            grupoActual.fechaFin = fechaActual;
            grupoActual.total += entregasPorFecha[fechasOrdenadas[i]].total;
            // ✨ CAMBIO 3: Concatenamos las listas de solicitudes al unir grupos.
            grupoActual.solicitudes = grupoActual.solicitudes.concat(entregasPorFecha[fechasOrdenadas[i]].solicitudes);
        } else {
            gruposDePago.push(grupoActual);
            grupoActual = {
                fechaInicio: fechaActual,
                fechaFin: fechaActual,
                total: entregasPorFecha[fechasOrdenadas[i]].total,
                solicitudes: entregasPorFecha[fechasOrdenadas[i]].solicitudes
            };
        }
    }
    gruposDePago.push(grupoActual);

    // ✨ CAMBIO 4: Inicializamos ambos arreglos de salida.
    const resumenData = [];
    const asociacionesData = [];

    // --- Lógica para generar los pagos (sin cambios en el cálculo, pero ahora también poblamos `asociacionesData`) ---
    
    const formateadorFecha = new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit' });
    const formatearRango = (grupo) => {
        const inicio = formateadorFecha.format(grupo.fechaInicio);
        const fin = formateadorFecha.format(grupo.fechaFin);
        return inicio === fin ? `del ${inicio.substring(0,5)}` : `del ${inicio.substring(0,5)} al ${fin.substring(0,5)}`;
    };
    const formateadorFechaPago = new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });

    // --- 1er Pago (Adelanto) ---
    if (gruposDePago.length > 0) {
        const primerGrupo = gruposDePago[0];
        const fechaPrimerPago = new Date(primerGrupo.fechaInicio);
        fechaPrimerPago.setDate(fechaPrimerPago.getDate() - 14);

        resumenData.push([
            '1er pago',
            `Adelanto trabajos ${formatearRango(primerGrupo)}`,
            `Máximo hasta el ${formateadorFechaPago.format(fechaPrimerPago)}`,
            formatearPrecio(primerGrupo.total * 0.5)
        ]);

        // ✨ CAMBIO 5: Generamos la asociación para el primer pago.
        asociacionesData.push({
            pago: '1er pago',
            asociaciones: primerGrupo.solicitudes.map(sol => ({
                id: sol.id,
                concepto: 'Adelanto 50%',
                monto: sol.proPlataforma.precioEmpresa * 0.5
            }))
        });
    }

    // --- Pagos Intermedios (Saldo + Adelanto) ---
    for (let i = 0; i < gruposDePago.length - 1; i++) {
        const grupoActual = gruposDePago[i];
        const grupoSiguiente = gruposDePago[i + 1];
        const fechaDePago = new Date(grupoActual.fechaFin);
        fechaDePago.setDate(fechaDePago.getDate() - 2);
        const valorPago = (grupoActual.total * 0.5) + (grupoSiguiente.total * 0.5);
        const numeroPago = `${i + 2}° pago`;

        resumenData.push([
            numeroPago,
            `Saldo trabajos ${formatearRango(grupoActual)} y Adelanto ${formatearRango(grupoSiguiente)}`,
            formateadorFechaPago.format(fechaDePago),
            formatearPrecio(valorPago)
        ]);

        // ✨ CAMBIO 6: Generamos las asociaciones para los pagos intermedios.
        const asociacionesSaldo = grupoActual.solicitudes.map(sol => ({
            id: sol.id,
            concepto: 'Saldo 50%',
            monto: sol.proPlataforma.precioEmpresa * 0.5
        }));
        const asociacionesAdelanto = grupoSiguiente.solicitudes.map(sol => ({
            id: sol.id,
            concepto: 'Adelanto 50%',
            monto: sol.proPlataforma.precioEmpresa * 0.5
        }));
        asociacionesData.push({
            pago: numeroPago,
            asociaciones: [...asociacionesSaldo, ...asociacionesAdelanto]
        });
    }

    // --- Último Pago (Saldo Final) ---
    if (gruposDePago.length > 0) {
        const ultimoGrupo = gruposDePago[gruposDePago.length - 1];
        const numeroPago = `${gruposDePago.length + (gruposDePago.length > 1 ? 0 : 1)}° pago`;
        
        resumenData.push([
            numeroPago,
            `Saldo final trabajos ${formatearRango(ultimoGrupo)}`,
            formateadorFechaPago.format(ultimoGrupo.fechaFin),
            formatearPrecio(ultimoGrupo.total * 0.5)
        ]);

        // ✨ CAMBIO 7: Generamos la asociación para el último pago.
        asociacionesData.push({
            pago: numeroPago,
            asociaciones: ultimoGrupo.solicitudes.map(sol => ({
                id: sol.id,
                concepto: 'Saldo 50%',
                monto: sol.proPlataforma.precioEmpresa * 0.5
            }))
        });
    }

    // ✨ CAMBIO 8: Retornamos el objeto con ambas propiedades.
    return { resumen: resumenData, asociaciones: asociacionesData };
};

export const generarYVerificarPlanCompleto = (solicitudes, servicios, formatearPrecio) => {
    console.clear(); // Limpia la consola para una nueva verificación
    console.log("--- 🚀 INICIANDO VERIFICACIÓN DEL PLAN DE PAGOS ---");
    console.log("Solicitudes recibidas:", solicitudes);
    console.log("Servicios recibidos:", servicios);

    // 1. Generamos el plan teórico
    const { resumen, asociaciones } = generarPlanDePagos(solicitudes, formatearPrecio);
    if (!asociaciones || asociaciones.length === 0) {
        console.warn("⚠️ No se generaron asociaciones en el plan de pagos. Terminando.");
        return { resumen: [], planVerificado: [] };
    }
    console.log("Plan de pagos teórico generado:", asociaciones);

    // 2. Creamos el mapa de códigos
    const codigoPorSolicitudId = new Map();
    servicios.forEach(servicio => {
        if (servicio.idsolicitud && servicio.codigo) {
            codigoPorSolicitudId.set(String(servicio.idsolicitud), servicio.codigo);
        }
    });
    console.log("🗺️ Mapa de Códigos por ID de Solicitud creado. Tamaño:", codigoPorSolicitudId.size, codigoPorSolicitudId);

    // 3. Calculamos el saldo total del cliente
    const pagosCliente = servicios
        .flatMap(servicio => servicio.pagos || [])
        .filter(pago => pago.tipopago === 'CLIENTES');
    
    const saldoTotalAFavor = pagosCliente.reduce((sum, pago) => sum + pago.valor, 0);
    
    console.log("💰 Pagos de 'CLIENTES' encontrados:", pagosCliente);
    console.log(`✅ Saldo Total a Favor del Cliente: ${formatearPrecio(saldoTotalAFavor)}`);

    // 4. Verificamos el plan
    let montoAplicadoGlobalmente = 0;
    console.log("\n--- 📊 PROCESANDO CUOTAS DEL PLAN ---");

    const planVerificado = asociaciones.map((pagoProgramado, index) => {
        console.log(`\n🔵 Procesando Cuota #${index + 1}: "${pagoProgramado.pago}"`);

        const asociacionesVerificadas = pagoProgramado.asociaciones.map(asociacion => {
            const { id, concepto, monto } = asociacion;

            const saldoDisponible = Math.max(0, saldoTotalAFavor - montoAplicadoGlobalmente);
            const montoCubierto = Math.min(monto, saldoDisponible);
            const saldoPendiente = monto - montoCubierto;
            
            console.log(
              `  - Solicitud #${id} (${concepto}):` +
              `\n    - Requiere: ${formatearPrecio(monto)}` +
              `\n    - Saldo Global Disponible: ${formatearPrecio(saldoDisponible)}` +
              `\n    - Se cubre: ${formatearPrecio(montoCubierto)}` +
              `\n    - Saldo Pendiente (de esta parte): ${formatearPrecio(saldoPendiente)}`
            );
            
            // "Gastamos" lo que se cubrió
            montoAplicadoGlobalmente += montoCubierto;
            console.log(`    - Monto Global Aplicado ahora es: ${formatearPrecio(montoAplicadoGlobalmente)}`);

            const estado = saldoPendiente <= 0 
                ? { texto: 'Pagado', color: 'green' } 
                : { texto: 'Pendiente', color: 'red' };

            return {
                ...asociacion,
                montoCubierto,
                saldoPendiente,
                estado,
                codigo: codigoPorSolicitudId.get(String(id)) || null 
            };
        });

        return {
            ...pagoProgramado,
            asociaciones: asociacionesVerificadas
        };
    });

    console.log("\n\n--- ✅ VERIFICACIÓN COMPLETA ---");
    console.log("Resultado final (planVerificado):", planVerificado);

    return { resumen, planVerificado };
};

//generar y verificar plan completo backup
/*
export const generarYVerificarPlanCompleto = (solicitudes, servicios, formatearPrecio) => {
    console.clear(); // Limpia la consola para una nueva verificación
    console.log("--- 🚀 INICIANDO VERIFICACIÓN DEL PLAN DE PAGOS ---");
    console.log("Solicitudes recibidas:", solicitudes);
    console.log("Servicios recibidos:", servicios);

    // 1. Generamos el plan teórico
    const { resumen, asociaciones } = generarPlanDePagos(solicitudes, formatearPrecio);
    if (!asociaciones || asociaciones.length === 0) {
        console.warn("⚠️ No se generaron asociaciones en el plan de pagos. Terminando.");
        return { resumen: [], planVerificado: [] };
    }
    console.log("Plan de pagos teórico generado:", asociaciones);

    // 2. Creamos el mapa de códigos
    const codigoPorSolicitudId = new Map();
    servicios.forEach(servicio => {
        if (servicio.idsolicitud && servicio.codigo) {
            codigoPorSolicitudId.set(String(servicio.idsolicitud), servicio.codigo);
        }
    });
    console.log("🗺️ Mapa de Códigos por ID de Solicitud creado. Tamaño:", codigoPorSolicitudId.size, codigoPorSolicitudId);

    // 3. Calculamos el saldo total del cliente
    const pagosCliente = servicios
        .flatMap(servicio => servicio.pagos || [])
        .filter(pago => pago.tipopago === 'CLIENTES');
    
    const saldoTotalAFavor = pagosCliente.reduce((sum, pago) => sum + pago.valor, 0);
    
    console.log("💰 Pagos de 'CLIENTES' encontrados:", pagosCliente);
    console.log(`✅ Saldo Total a Favor del Cliente: ${formatearPrecio(saldoTotalAFavor)}`);

    // 4. Verificamos el plan
    let montoAplicadoGlobalmente = 0;
    console.log("\n--- 📊 PROCESANDO CUOTAS DEL PLAN ---");

    const planVerificado = asociaciones.map((pagoProgramado, index) => {
        console.log(`\n🔵 Procesando Cuota #${index + 1}: "${pagoProgramado.pago}"`);

        const asociacionesVerificadas = pagoProgramado.asociaciones.map(asociacion => {
            const { id, concepto, monto } = asociacion;

            const saldoDisponible = Math.max(0, saldoTotalAFavor - montoAplicadoGlobalmente);
            const montoCubierto = Math.min(monto, saldoDisponible);
            const saldoPendiente = monto - montoCubierto;
            
            console.log(
              `  - Solicitud #${id} (${concepto}):` +
              `\n    - Requiere: ${formatearPrecio(monto)}` +
              `\n    - Saldo Global Disponible: ${formatearPrecio(saldoDisponible)}` +
              `\n    - Se cubre: ${formatearPrecio(montoCubierto)}` +
              `\n    - Saldo Pendiente (de esta parte): ${formatearPrecio(saldoPendiente)}`
            );
            
            // "Gastamos" lo que se cubrió
            montoAplicadoGlobalmente += montoCubierto;
            console.log(`    - Monto Global Aplicado ahora es: ${formatearPrecio(montoAplicadoGlobalmente)}`);

            const estado = saldoPendiente <= 0 
                ? { texto: 'Pagado', color: 'green' } 
                : { texto: 'Pendiente', color: 'red' };

            return {
                ...asociacion,
                montoCubierto,
                saldoPendiente,
                estado,
                codigo: codigoPorSolicitudId.get(String(id)) || null 
            };
        });

        return {
            ...pagoProgramado,
            asociaciones: asociacionesVerificadas
        };
    });

    console.log("\n\n--- ✅ VERIFICACIÓN COMPLETA ---");
    console.log("Resultado final (planVerificado):", planVerificado);

    return { resumen, planVerificado };
};
*/